<script>
import { mapState } from "vuex";
import Layout from "@/router/layouts/main";
import moment from "moment";
import { api } from "@/state/services";
import Binary from "@/components/widgets/network-matriz";

export default {
  locales: {
    pt: {
      'Left Team': 'Equipe Esquerda',
      'Right Team': 'Equipe Direita',
      'CURRENT': 'ATUAL',
      'TOTAL': 'TOTAL',
      'TEAM': 'EQUIPE',
      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.',

      'Username': 'Usuário',
      'Username is required.': 'O usuário é obrigatório.',
      'Search': 'Buscar',
      'The username was not found.': 'O usuário não foi encontrado.',
    },
    es: {
      'Left Team': 'Equipe Izquierda',
      'Right Team': 'Equipe Derecha',
      'CURRENT': 'ACTUAL',
      'TOTAL': 'TOTAL',
      'TEAM': 'EQUIPO',
      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtelo de nuevo más tarde.',

      'Username': 'Usuário',
      'Username is required.': 'Nombre de usuario es requerido.',
      'Search': 'Buscar',
      'The username was not found.': 'No se encontró el nombre de usuario.',
    }
  },
  components: {
    Layout,
    Binary,
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  data() {
    return {
      month_year: moment().format("MM/YY"),

      loading: true,
      errored: false,

      id: this.$route.params.id,
      username: null,
      name: null,
      image: null,

      resume: {
        points: {
          left: "-",
          right: "-",
        },
        personal: "-",
        minor: "-",
        total: "-",
        plan: {
          status: "no",
          ceiling: "0,00",
        },
      },

      left: {
        current: '0',
        users: '0',
      },
      right: {
        current: '0',
        users: '0',
      },

      tree: null,
      levels: [],
      list: null,
    }
  },
  methods: {
    getBinary() {
      api
        .get('network/test/binary')
        .then(response => {
          if (response.data.status == 'success') {
            this.left.current = response.data.points.current.left
            this.left.users = response.data.users.left

            this.right.current = response.data.points.current.right
            this.right.users = response.data.users.right

            this.username = response.data.user.username
            this.name = response.data.user.name
            this.image = response.data.user.image

            this.tree = response.data.tree

            this.levels = response.data.levels
            this.list = response.data.list
          }
        })
        .catch(error => {
          this.errored = error
          this.loading = false
        })
        .finally(() => {
          this.errored = false
          this.loading = false
        })
    },
  },
  mounted() {
    this.getBinary();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Rede</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Matriz 2x15 Bilateral</h3>
        <p></p>
      </div>
    </div>

    <fieldset class="pb-0">
      <legend>
        Pontos
      </legend>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-subdirectory-left font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ resume.points.left }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">L. Esquerdo</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-subdirectory-right font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ resume.points.right }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">L. Direito</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-check-double font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ resume.personal }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">Pontos Pessoais</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-dollar font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ resume.minor }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">L. Menor</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-dollar font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold">{{ resume.total }}</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">Total</p>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-6 mb-3">
          <div class="d-flex align-items-center">
            <div>
              <div class="bg-light rounded py-1 px-2">
                <i class="bx bx-dollar font-size-24 my-1 align-middle"></i>
              </div>
            </div>
            <div class="flex-fill ml-2">
              <h5 class="mb-0 notranslate font-weight-bold" v-if="resume.plan.status == 'yes' && resume.plan.ceiling > 0">{{ resume.plan.ceiling | currency }}</h5>
              <h5 class="mb-0 notranslate font-weight-bold" v-else-if="resume.plan.status == 'no' && resume.plan.ceiling > 0">R$ 0,00</h5>
              <h5 class="mb-0 notranslate font-weight-bold font-size-16" v-else>Ilimitado</h5>
              <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12">Teto</p>
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <div class="card">
      <div class="card-body">
        <Binary :data="tree"></Binary>
      </div>
    </div>

    <fieldset>
      <legend>Níveis</legend>
      <table class="table table-centered table-nowrap">
        <thead class="thead-light">
          <tr>
            <th class="text-center">Nível</th>
            <th class="text-center">Qtd Atual</th>
            <th class="text-center">Qtd Máxima</th>
            <th class="text-center">Falta Completar</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in levels" :key="row.level">
            <td class="text-center">{{ row.level }}º</td>
            <td class="text-center">{{ row.current | points }}</td>
            <td class="text-center">{{ row.total | points }}</td>
            <td class="text-center">{{ row.missing | points }}</td>
            <td class="text-center">
              <span class="badge badge-soft-success font-size-12" v-if="row.missing == '0'">COMPLETO</span>
              <span class="badge badge-soft-warning font-size-12" v-else>INCOMPLETO</span>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>

    <fieldset>
      <legend>Lista</legend>

      <div v-if="!list" class="text-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>

      <div v-else-if="list && list.length == 0">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum registro encontrado
        </div>
      </div>

      <div v-else class="table-responsive">
        <table class="table table-centered table-nowrap">
          <thead class="thead-light">
            <tr>
              <th>Usuário</th>
              <th>Nome</th>
              <th>Patrocinador</th>
              <th>Fase</th>
              <th>Nível</th>
              <th>Lado</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(td, index) in list" :key="index">
              <td>{{ td.username }}</td>
              <td>{{ td.name }}</td>
              <td>{{ td.sponsor }}</td>
              <td>{{ td.plan }}</td>
              <td>{{ td.level }}</td>
              <td>
                <span class="badge badge-soft-default font-size-12" v-if="td.side == 'l'">ESQUERDO</span>
                <span class="badge badge-soft-default font-size-12" v-else-if="td.side == 'r'">DIREITO</span>
              </td>
              <td>
                <div v-if="td.monthly.status == 'active'"><span class="badge badge-soft-success font-size-12">ATIVO</span> – <span class="font-size-12">{{ td.monthly.date }}</span></div>
                <span v-else-if="td.monthly.status == 'inactive'" class="badge badge-soft-danger font-size-12">INATIVO</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>
  </Layout>
</template>
